var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.00191V15.0019C0 15.8619 1.012 16.3199 1.659 15.7549L9.659 8.75491C9.76641 8.66105 9.8525 8.54529 9.91148 8.41542C9.97046 8.28554 10.001 8.14455 10.001 8.00191C10.001 7.85927 9.97046 7.71828 9.91148 7.5884C9.8525 7.45852 9.76641 7.34277 9.659 7.24891L1.659 0.248909C1.012 -0.316091 0 0.142909 0 1.00191ZM11 1.00191V15.0019C11 15.8619 12.012 16.3199 12.659 15.7549L20.659 8.75491C20.7664 8.66105 20.8525 8.54529 20.9115 8.41542C20.9705 8.28554 21.001 8.14455 21.001 8.00191C21.001 7.85927 20.9705 7.71828 20.9115 7.5884C20.8525 7.45852 20.7664 7.34277 20.659 7.24891L12.659 0.248909C12.012 -0.316091 11 0.142909 11 1.00191Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutNext);
export default __webpack_public_path__ + "static/media/about_next.ba4633670d5877de2fe723a18cce2e79.svg";
export { ForwardRef as ReactComponent };